let FileboxLayout = () => import("../components/filebox/FileboxLayout");
let FileboxIndex = () => import("../pages/filebox/FileboxIndex");
let FileboxTrash = () => import("../pages/filebox/FileboxTrash");

export default [
    {
        path: "/filebox",
        component: FileboxLayout,
        redirect: "/filebox/index",
        children: [
            {
                path: "index",
                component: FileboxIndex,
                name: "FileboxIndex",
                meta: { requiresAuth: true },
            },
            {
                path: "list/:folderId?",
                component: FileboxIndex,
                name: "FileboxFiles",
                meta: { requiresAuth: true },
            },
            {
                path: "trash",
                component: FileboxTrash,
                name: "FileboxTrash",
                meta: { requiresAuth: true },
            },
        ],
    },
    
];
